import { EventDoc, EventReminder } from 'types/api/changes'

export function generateDefaultReminder(
  allDay?: boolean,
  startTime?: string
): EventReminder {
  return {
    AlertTime: allDay ? String(Number(startTime) + 9 * 60 * 60) : '',
    isOn: '1',
    isRelativeReminder: allDay ? '0' : '1',
    offset: allDay ? -9 * 60 * 60 : 60 * 60
  }
}
